import React, { useEffect, useRef } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { useRecordScanMutation } from "./printsApi";
import { TODAY_PRINTS_PATH } from "./paths";

// /aotd/<number>: no page of its own any more. Every printed QR code points here
// (https://n450s.com/aotd/<number>?pst=<print>), so it must never be a dead link: with a ?pst
// it records the scan, then it lands on today's prints, with a note naming the scanned print.
// Waits for the session restore so a signed-in scan carries the username.

const AotdScanRedirect: React.FC = () => {
  const params = useParams();
  const { search } = useLocation();
  const authReady = useAppSelector((s) => s.auth.bootstrapStatus === "ready");
  const [recordScan] = useRecordScanMutation();
  const sent = useRef(false);

  const number = Number(params.number);
  const valid = Number.isInteger(number) && number > 0;
  const pst = new URLSearchParams(search).get("pst")?.trim().toLowerCase() || null;

  useEffect(() => {
    if (!authReady || !valid || !pst || sent.current) return;
    sent.current = true;
    recordScan({ number, pst });
  }, [authReady, valid, pst, number, recordScan]);

  if (!authReady) return null;
  const to = valid && pst ? `${TODAY_PRINTS_PATH}?scanned=${number}` : TODAY_PRINTS_PATH;
  return <Navigate replace to={to} />;
};

export default AotdScanRedirect;
